import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import DropDownOA from '../../../../common/dropDownOA'
import { URRBRMidFCheckBoxList, LuggBookRightscolumn, URRBRMidLeftData, URRBRMidLeftDropData, URRBRMidSCheckBoxList, URRBRMidThCheckBoxList, ApprAuthority, URRBRMidLeftDropDataV2, accessName, accessNameV2, dashboardAccessLevels } from '../../constants'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import { clickElement, focusElemnt, getFloat, navigation1, navigation3 } from '../../../../common/helper'
import { Stack } from '@mui/system'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import InfoIcon from '@mui/icons-material/Info'
import { useEffect } from 'react'
import LineinputV2 from '../../../../common/lineinputV2'
import {userRRLuggageBookRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import OTPModal from '../OTPModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'

const LuggageBookingRights = (props) => {
    const { data, updateModal, luggageRightsValue, userRRLuggageBookRightsSave, userRollRightSendOTP, updateAlertError, setLuggageRightsValue, luggageTableData, setLuggageTableData, roleId, otpOnUserRights,loginData } = props
    const { common, } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [selApprAuth, setSelApprAuth] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })

    useEffect(() => {
        focusElemnt("LBPaid-0")
    }, [])

    const handleTblKeyDown = (e, top, bottom, left, right, nextId, prevId, currentId) => {
        if (e.key === ' ') {
            clickElement(currentId)
        } else if (e.key === 'ArrowDown') {
            focusElemnt(bottom)
        } else if (e.key === 'ArrowUp') {
            focusElemnt(top)
        } else if (e.key === 'ArrowLeft') {
            focusElemnt(left)
        } else if (e.key === 'ArrowRight') {
            focusElemnt(right)
        } else if (e.key === 'Escape') {
            focusElemnt(prevId)
        } else if (e.key === 'Enter') {
            focusElemnt(nextId)
        }
    }

    const handleLuggageRightValue = (value, field1, field2, previousVal) => {
        if (value != previousVal) {
            setLuggageRightsValue((prev) => ({ ...prev, [field1]: value, [field2]: 0 }))
        }
    }
    const handleChange = (value, field) => {
        setLuggageRightsValue({ ...luggageRightsValue, [field]: value })
    }

    const handleCheckBox = (value, index, field) => {
        let newData = [...luggageTableData]
        newData[index][field] = value
        setLuggageTableData(newData)
    }


    const saveApi = () => {
        let newData = transferArrToObject(luggageTableData?.filter((val) => ![7, 14].includes(val.BookingRightsID)))

        const obj = {
            RoleID: roleId,
            BookingRightsIDs: newData?.BookingRightsID,
            Allowed: newData?.Allowed,
            Paid: newData?.Paid,
            TOPAY: newData?.Topay,
            FOC: newData?.FOC,
            COD: newData?.COD,
            OnAcc: newData?.OnAcc,
            Self: newData?.Self,
            ToPayDDDV: newData?.ToPayDDDV,
            PaidMan: newData?.PaidMan,
            ToPayMan: newData?.TopayMan,
            OnaccMan: newData?.OnAccMan,
            AllowFareChange: luggageRightsValue?.AllowFareChange?.dropId,
            LimitOnFareChange: Number(luggageRightsValue?.LimitOnFareChange),
            LimitOnFareChangePer: Number(luggageRightsValue?.LimitOnFareChangePer),
            AllowUpdate: luggageRightsValue?.AllowUpdate,
            AllowUpdateAll: luggageRightsValue?.AllowUpdateAll,
            AllowUpdateOtherBranch: luggageRightsValue?.AllowUpdateOtherBranches,
            AllowReprint: luggageRightsValue?.AllowReprint,
            AllowExportExcel: luggageRightsValue?.AllowExportExcel,
            AllowPrintandPdf: luggageRightsValue?.AllowPrintandPdf,
            AllowViewAllBranchReport: luggageRightsValue?.AllowViewAllBranchReport,
            AllowViewAllBranchOfCityReport: luggageRightsValue?.AllowViewAllBranchOfCityReport,
            AllowShortReceipt: luggageRightsValue?.AllowShortReceipt,
            AllowHamaliEdit: luggageRightsValue?.AllowHamaliEdit?.dropId,
            MaxHamaliPerLR: Number(luggageRightsValue?.MaxHamaliPerLR),
            MaxHamaliPerUnit: Number(luggageRightsValue?.MaxHamaliPerUnit),
            AllowPartyBooking: luggageRightsValue?.AllowPartyBooking,
            AllowAllBranchLRCancel: luggageRightsValue?.AllowAllBranchLRCancel,
            AllowPartyVoucher: luggageRightsValue?.AllowPartyVoucher,
            AllowDispatchGodown: luggageRightsValue?.AllowDispatchGodown,
            AllowBranchDetSMS: luggageRightsValue?.AllowBranchDetSMS,
            AllowOptHamaliEdit: luggageRightsValue?.AllowOperatorHamaliEdit?.dropId,
            MaxOptHamaliPerLR: Number(luggageRightsValue?.MaxOperatorHamaliPerLR),
            MaxOptHamaliPerUnit: Number(luggageRightsValue?.MaxOperatorHamaliPerUnit),
            AllowDelChgChange: luggageRightsValue?.AllowDelChgChange?.dropId,
            LimitOnDelChange: Number(luggageRightsValue?.LimitOnDelChange),
            AllowDemChgChange: luggageRightsValue?.AllowDemChgChange?.dropId,
            LimitOnDemChange: Number(luggageRightsValue?.LimitOnDemChange),
            AllowBranchIncharge: luggageRightsValue?.AllowBranchInchargeRights,
            AllowShowAdditional: luggageRightsValue?.AllowShowAdditional,
            AllowRollBack: luggageRightsValue?.AllowRollBack,
            AllowAdminCancelDispatch: luggageRightsValue?.AllowAdminCancelDispatch,
            AllowAdminCancelReceive: luggageRightsValue?.AllowAdminCancelReceive,
            AllowAdminDispatchChange: luggageRightsValue?.AllowAdminDispatchChange,
            AllowAdminDestinationChange: luggageRightsValue?.AllowAdminDestinationChange,
            AllowAdminSendAndRecChange: luggageRightsValue?.AllowAdminSendAndRecChange,
            AllowLitReceive: luggageRightsValue?.AllowLitReceive,
            AllowDeliveryDisc: luggageRightsValue?.AllowDeliveryDisc,
            AllowUserChangeBranch: luggageRightsValue?.AllowUserChangeBranch,
            AllowUserViewAllDelivery: luggageRightsValue?.AllowUserViewAllDelivery,
            AllowBookingRCM: luggageRightsValue?.IsBookingRCM,
            AllowDeliveryRCM: luggageRightsValue?.IsDeliveryRCM,
            AllowCancelThruAnyBrAndUser: luggageRightsValue?.AllowCancelThruAnyBrAndUser,
            AllowMarkAsLost: luggageRightsValue?.AllowMarkAsLost,
            DisAllowFareReduction: luggageRightsValue?.DisallowFareReduction,
            AllowExportCommission: luggageRightsValue?.AllowExportCommission,
            AllowGroupofCompanies: luggageRightsValue?.AllowGroupofCompanies,
            AllowBranchselection: luggageRightsValue?.AllowBranchselection,
            DashboardAccessLevel: luggageRightsValue?.DashboardAccessLevel
        }
        userRRLuggageBookRightsSave(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen({ ...isOpen, open: true, message: "Luggage BOOKING RIGHTS\nSaved Successfully!" })
            } else {
                setSaveError({ ...saveError, error: true, message: res.Message })
            }
        }).catch((err) => {
            setSaveError({ ...saveError, error: true, message: err })
        })
    }
    const transferArrToObject = (arr) => {
        const newObject = arr.reduce((result, obj) => {
            Object.keys(obj).forEach(key => {
                result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
            });
            return result;
        }, {});
        return newObject
    }

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
        })
    }

    const onSave = () => {
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
    }
    const checkingCheckboxValue = (field, id) => {
        let filteredData = luggageTableData?.filter((val) => val.BookingRightsID === id)
        return filteredData?.[0]?.[field] === 1
    }
    const handleTableCheckBoxValue = (value, field, id) => {
        let newData = [...luggageTableData]
        const updateData = newData?.map((val) => val.BookingRightsID === id ? ({ ...val, [field]: value }) : val)
        setLuggageTableData(updateData)
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            [1, 2, 6].includes(item.BookingRightsID) ?
                <TableRow key={`URR-${index}`}>
                    <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#444', fontWeight: "500", }}>{item.BookingRightsName}</TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#444', fontWeight: "500" }}>
                        <Checkbox
                            checked={item?.Paid == 1}
                            id={`LBPaid-${index}`}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBPaid-${index - 1}`, index === 2 ? `LBPaid-0` : `LBPaid-${index + 1}`,
                                    `LBToPayDDDV-${index}`, `LBPaidMan-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBPaid-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Paid")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            checked={item?.PaidMan == 1}
                            id={`LBPaidMan-${index}`}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBPaidMan-${index - 1}`, index === 2 ? `LBPaidMan-0` : `LBPaidMan-${index + 1}`,
                                    `LBPaid-${index}`, `LBToPay-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBPaidMan-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "PaidMan")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBToPay-${index}`}
                            checked={item?.Topay == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBToPay-${index - 1}`, index === 2 ? `LBToPay-0` : `LBToPay-${index + 1}`,
                                    `LBPaidMan-${index}`, `LBToPayMan-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBToPay-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Topay")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBToPayMan-${index}`}
                            checked={item?.TopayMan == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBToPayMan-${index - 1}`, index === 2 ? `LBToPayMan-0` : `LBToPayMan-${index + 1}`,
                                    `LBToPay-${index}`, `LBOnAcc-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBToPayMan-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "TopayMan")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBOnAcc-${index}`}
                            checked={item?.OnAcc == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBOnAcc-${index - 1}`, index === 2 ? `LBOnAcc-0` : `LBOnAcc-${index + 1}`,
                                    `LBToPayMan-${index}`, `LBOnAccMan-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBOnAcc-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "OnAcc")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBOnAccMan-${index}`}
                            checked={item?.OnAccMan == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBOnAccMan-${index - 1}`, index === 2 ? `LBOnAccMan-0` : `LBOnAccMan-${index + 1}`,
                                    `LBOnAcc-${index}`, `LBFOC-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBOnAccMan-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "OnAccMan")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBFOC-${index}`}
                            checked={item?.FOC == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBFOC-${index - 1}`, index === 2 ? `LBFOC-0` : `LBFOC-${index + 1}`,
                                    `LBOnAcc-${index}`, `LBCOD-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBFOC-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "FOC")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBCOD-${index}`}
                            checked={item?.COD == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBCOD-${index - 1}`, index === 2 ? `LBCOD-0` : `LBCOD-${index + 1}`,
                                    `LBFOC-${index}`, `LBSelf-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBCOD-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "COD")}
                        />
                    </TableCell>
                    <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBSelf-${index}`}
                            checked={item?.Self == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBSelf-${index - 1}`, index === 2 ? `LBSelf-0` : `LBSelf-${index + 1}`,
                                    `LBCOD-${index}`, `LBToPayDDDV-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBSelf-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "Self")}
                        />
                    </TableCell><TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                        <Checkbox
                            id={`LBToPayDDDV-${index}`}
                            checked={item?.ToPayDDDV == 1}
                            sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                            onKeyDown={(e) =>
                                handleTblKeyDown(e, index === 0 ? `` : `LBToPayDDDV-${index - 1}`, index === 2 ? `LBToPayDDDV-0` : `LBToPayDDDV-${index + 1}`,
                                    `LBSelf-${index}`, `LBPaid-${index}`, "LuggageRightDrop-0", "LuggageRightSave", `LBToPayDDDV-${index}`
                                )}
                            onChange={(e) => handleCheckBox(e.target.checked ? 1 : 0, index, "ToPayDDDV")}
                        />
                    </TableCell>
                </TableRow>
                : null
        )
    }

    return (
        <>
            <Box sx={{ padding: "16px", paddingBottom: "0px" }}>
                <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '65vh', marginBottom: "5px" }} >
                    <Table stickyHeader size="small" aria-label="a dense table" sx={{
                        '& .MuiTableCell-root': {
                            padding: '6px !important'
                        }
                    }}>
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                            <TableRow>
                                {LuggBookRightscolumn.map((col, index) =>
                                    <TableCell key={`TH-${index}`} style={{ ...col.headerSx, textAlign: index == 0 ? "" : "center", backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {luggageTableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box>
                    <Grid container spacing={2} sx={{ display: "flex", alignItems: "start" }}>
                        <Grid item md={5}>
                            {
                                URRBRMidLeftData?.map((item, i) => {
                                    return (
                                        <Box className={`urrBookRightsMid ${i > 2 ? "BranchAndUsrBottomSec" : ""}`} key={i}>
                                            <p className='URRBookRMidheading'>{item.heading}</p>
                                            <Item sx={sx.itemsx} style={{ width: "145px" }}>
                                                <DropDownOA
                                                    id={`LuggageRightDrop-${i}`}
                                                    defaultvalue={luggageRightsValue?.[item.dropField]?.dropValue || ""}
                                                    value={luggageRightsValue?.[item.dropField]?.dropValue || ""}
                                                    data={i == 3 || i == 4 ? URRBRMidLeftDropDataV2 : URRBRMidLeftDropData || []}
                                                    width="100%"
                                                    listWidth={"150px"}
                                                    searchPlaceholder={`Search`}
                                                    label={""}
                                                    dataKey={`dropValue`}
                                                    idKey={`dropId`}
                                                    nextId={`LRightFirstInp-${i}`}
                                                    prevId={i == 0 ? `LBPaid-0` : `LRightSecondInp-${i - 1}`}
                                                    onSelect={(value) => setLuggageRightsValue((prev) => ({ ...prev, [item.dropField]: value, [item.amtField]: 0, [item.perField]: 0 }))}
                                                />
                                            </Item>
                                            <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "60px" }}>
                                                <LineinputV2
                                                    id={`LRightFirstInp-${i}`}
                                                    disabled={[3, 4].includes(i) || luggageRightsValue?.[item.dropField]?.dropId !== accessName.LIMITED}
                                                    label={item.FInpLabel}
                                                    value={luggageRightsValue?.[item.amtField]}
                                                    type="text"
                                                    name="PAN"
                                                    sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                                    filter={getFloat}
                                                    onBlur={(e) => handleLuggageRightValue(e.target.value, item.amtField, item.perField, luggageRightsValue?.[item.amtField])}
                                                    onKeyDown={(e) => navigation1(e, `LRightSecondInp-${i}`, `LuggageRightDrop-${i}`)}
                                                />
                                            </Box>
                                            <Box className={'input--wrapper'} style={{ marginBottom: "0px", width: "60px" }}>
                                                <LineinputV2
                                                    id={`LRightSecondInp-${i}`}
                                                    disabled={[3, 4].includes(i)?luggageRightsValue?.[item.dropField]?.dropId !== accessNameV2.LIMITED:luggageRightsValue?.[item.dropField]?.dropId !== accessName.LIMITED}
                                                    label={item.SInpLabel}
                                                    value={luggageRightsValue?.[item.perField]}
                                                    type="text"
                                                    name="PAN"
                                                    sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                                    onKeyDown={(e) => navigation1(e, URRBRMidLeftData?.length === i + 1 ? `LRightsFirstCheck-0` : `LuggageRightDrop-${i + 1}`, `LRightFirstInp-${i}`)}
                                                    filter={getFloat}
                                                    onBlur={(e) => handleLuggageRightValue(e.target.value, item.perField, item.amtField, luggageRightsValue?.[item.perField])}
                                                />
                                            </Box>
                                        </Box>
                                    )
                                })
                            }
                            <Box className={`urrBookRightsMid`}>
                                <p className='URRBookRMidheading'>Dashboard Access level</p>
                                <Item sx={sx.itemsx} style={{ width: "280px" }}>
                                    <DropDownOA
                                        id={`LuggageRightDrop-DashboardAccessLevel`}
                                        defaultvalue={dashboardAccessLevels.find((level) => level.id === luggageRightsValue?.DashboardAccessLevel)?.name || ""}
                                        value={dashboardAccessLevels.find((level) => level.id === luggageRightsValue?.DashboardAccessLevel)?.name || ""}
                                        data={dashboardAccessLevels}
                                        width="100%"
                                        listWidth={"280px"}
                                        searchPlaceholder={`Search`}
                                        label={""}
                                        dataKey={`name`}
                                        idKey={`id`}
                                        portal={true}
                                        onSelect={(value) => setLuggageRightsValue((prev) => ({ ...prev, DashboardAccessLevel: value.id, }))}
                                    />
                                </Item>
                            </Box>
                        </Grid>
                        <Grid item md={7}>
                            <Item>
                                <Grid container spacing={2} sx={{ display: "flex", alignItems: "start" }}>
                                    <Grid item md={3.6}>
                                        {URRBRMidFCheckBoxList.map((obj, i) =>
                                            <Box>
                                                <FormControlLabel
                                                    key={i}
                                                    value="end"
                                                    // checked={specialRightsThirdValues[obj?.field] === 1}
                                                    control={<Checkbox id={`LRightsFirstCheck-${i}`} checked={obj.isTableData ? checkingCheckboxValue(obj.field2, obj.BookingRightsID) : luggageRightsValue[obj.field] === 1} sx={{ padding: '2px 5px 2px 5px' }} disabled={i == 1} />}
                                                    onKeyDown={(e) => {
                                                        navigation3(e, URRBRMidFCheckBoxList?.length === i + 1 ? `LRightsSecCheck-0` : `LRightsFirstCheck-${i + 1}`, i == 0 ? `LRightSecondInp-${URRBRMidLeftData?.length - 1}` : `LRightsFirstCheck-${i - 1}`, () => { })
                                                    }}
                                                    label={
                                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                            {obj.label}
                                                        </Typography>
                                                    }
                                                    onChange={(e) => { obj.isTableData ? handleTableCheckBoxValue(e.target.checked ? 1 : 0, obj.field2, obj.BookingRightsID) : handleChange(e.target.checked ? 1 : 0, obj.field) }}
                                                    labelPlacement="end"
                                                />
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid item md={4.2}>
                                        {URRBRMidSCheckBoxList.map((obj, i) =>
                                            <Box>
                                                <FormControlLabel
                                                    key={i}
                                                    value="end"
                                                    control={<Checkbox id={`LRightsSecCheck-${i}`} checked={obj.isTableData ? checkingCheckboxValue(obj.field2, obj.BookingRightsID) : luggageRightsValue[obj.field] === 1} sx={{ padding: '2px 5px 2px 5px' }} />}
                                                    onKeyDown={(e) => {
                                                        navigation3(e, URRBRMidSCheckBoxList?.length === i + 1 ? `LRightsThrdCheck-0` : `LRightsSecCheck-${i + 1}`, i == 0 ? `LRightsFirstCheck-${URRBRMidFCheckBoxList?.length - 1}` : `LRightsSecCheck-${i - 1}`, () => { })
                                                    }}
                                                    label={
                                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                            {obj.label}
                                                        </Typography>
                                                    }
                                                    onChange={(e) => { obj.isTableData ? handleTableCheckBoxValue(e.target.checked ? 1 : 0, obj.field2, obj.BookingRightsID) : handleChange(e.target.checked ? 1 : 0, obj.field) }}
                                                    labelPlacement="end"
                                                />
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid item md={4.2}>

                                        {URRBRMidThCheckBoxList.map((obj, i) =>
                                            <Box>
                                                <FormControlLabel
                                                    key={i}
                                                    value="end"
                                                    control={<Checkbox id={`LRightsThrdCheck-${i}`} checked={luggageRightsValue[obj.field] === 1} sx={{ padding: '2px 5px 2px 5px' }} disabled={[1,4,10,11].includes(i)} />}
                                                    onKeyDown={(e) => {
                                                        navigation3(e, URRBRMidSCheckBoxList?.length === i + 1 ? `LuggageRightAppAuth` : `LRightsThrdCheck-${i + 1}`, i == 0 ? `LRightsSecCheck-${URRBRMidSCheckBoxList?.length - 1}` : `LRightsThrdCheck-${i - 1}`, () => { })
                                                    }}
                                                    label={
                                                        <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                                            {obj.label}
                                                        </Typography>
                                                    }
                                                    onChange={(e) => handleChange(e.target.checked ? 1 : 0, obj.field)}
                                                    labelPlacement="end"
                                                />
                                            </Box>
                                        )}
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Stack className="itemButtons BranchAndUsrBottomSec">
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "5px", gap: "12px" }}>
                    <Box style={{ display: "flex" }}>
                        <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                            <DropDownOA
                                id={"LuggageRightAppAuth"}
                                data={ApprAuthority || []}
                                defaultvalue={selApprAuth?.name || ''}
                                width="100%"
                                searchPlaceholder={`Search Branch Name`}
                                label={"Approval Authority"}
                                dataKey={`name`}
                                idKey={`id`}
                                nextId={"LuggageRightCancel"}
                                field={'compulsory'}
                                prevId={`LRightsThrdCheck-${URRBRMidThCheckBoxList?.length - 1}`}
                                direction='up'
                                onSelect={(value) => setSelApprAuth(value)}
                            />
                        </Item>
                        <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                            <InfoIcon style={{ color: "#0086FF" }} />
                            <span style={{ color: "#1E59A7" }}>OTP will send to the Management as per Selection</span>
                        </Box>
                    </Box>
                    <Box style={{ display: "flex", gap: "15px" }}>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "LuggageRightSave", "LuggageRightAppAuth", () => { })}>
                            <Button id={"LuggageRightCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => { updateModal(false, "LuggageRightsUseRollRights"); focusElemnt("URRCatagoryNameInp") }}>
                                CANCEL
                            </Button>
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, `LBPaid-0`, "LuggageRightCancel", () => { })}>
                            <Button variant="contained" id="LuggageRightSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                                onClick={() => onSave()}
                            >
                                Save
                            </Button>
                        </Item>
                    </Box>
                </Box>
                {/* */}
            </Stack>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, userRRLuggageBookRightsSave, updateAlertError
}

export default connect(mapStateToProps, mapDispatchToProps)(LuggageBookingRights)